<template>
    <Teleport to="body">
        <dialog class="bottom-sheet" ref="dialogEl" @click="dialogClick">
            <header
                class="bottom-sheet__header"
                @touchstart.passive="handleTouchStart"
                @touchend.passive="handleTouchEnd"
            >
                <h2 v-if="heading">{{ heading }}</h2>
                <button @click="closeDialog">
                    <SvgIcon name="close-big" />
                </button>
            </header>
            <div class="bottom-sheet__body">
                <button
                    v-for="(item, index) in items"
                    :key="index"
                    class="bottom-sheet__cell"
                    :class="{ 'bottom-sheet__cell--active': activeValue === item.value }"
                    @click="selectValue(item.value)"
                >
                    {{ toTitleCase(item.name) }}
                </button>
            </div>
            <PanicButton />
        </dialog>
    </Teleport>
</template>

<script lang="ts" setup>
import { ref, watch } from "vue";

import SvgIcon from "@/shared/components/atoms/SvgIcon.vue";
import PanicButton from "@/shared/components/molecules/PanicButton.vue";

import useUtils from "@/shared/composables/use-utils";

type Item = {
    name: string;
    value: string;
};

const open = defineModel<boolean>("open", { required: true, default: false });
withDefaults(
    defineProps<{
        heading: string;
        items: Item[];
        activeValue?: string;
    }>(),
    {
        activeValue: "",
    },
);
const emit = defineEmits<{ selectValue: [value: string] }>();

const { toTitleCase } = useUtils();

const dialogEl = ref<HTMLDialogElement>(null);

watch(open, () => {
    if (dialogEl.value) {
        if (open.value) {
            dialogEl.value.showModal();
        } else {
            dialogEl.value.close();
        }
    }
});

const closeDialog = () => {
    open.value = false;
};

const selectValue = (value: string) => {
    emit("selectValue", value);
    closeDialog();
};

const dialogClick = (event: MouseEvent) => {
    if (event.target === dialogEl.value) {
        closeDialog();
    }
};

const swipeThreshold = 20;

let startY = 0;

const handleTouchStart = (event: TouchEvent) => {
    startY = event.touches[0].clientY;
};

const handleTouchEnd = (event: TouchEvent) => {
    const diffY = event.changedTouches[0].clientY - startY;

    if (Math.abs(diffY) > swipeThreshold && diffY > 0) {
        closeDialog();
    }
};
</script>
